import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FindClaimComponent } from './find-claim.component';

const routes: Routes = [{ path: '', component: FindClaimComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FindClaimRoutingModule {}
